import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./CheckoutStatusPage.css";

export default function CheckoutCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="checkout-page">
      <Navbar />
      <main className="checkout-main">
        <section className="checkout-card">
          <div className="checkout-icon cancel">!</div>
          <h1>Payment Cancelled</h1>
          <p>
            No payment was charged. You can review your cart and try checkout again.
          </p>
          <div className="checkout-actions">
            <button type="button" className="checkout-primary-btn" onClick={() => navigate("/cart")}>
              Back to Cart
            </button>
            <button type="button" className="checkout-secondary-btn" onClick={() => navigate("/e-store")}>
              Continue Shopping
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
